import type { TimestampNS } from '../types'

export const NS_PER_SECOND = 1_000_000_000

export function absoluteTimestamp(startNS: TimestampNS, offsetSeconds: number): TimestampNS {
  const offsetNS = BigInt(Math.round(offsetSeconds * NS_PER_SECOND))
  return (BigInt(startNS) + offsetNS).toString()
}

export function relativeSeconds(startNS: TimestampNS, timestampNS: TimestampNS): number {
  return Number(BigInt(timestampNS) - BigInt(startNS)) / NS_PER_SECOND
}

export function formatDuration(seconds: number): string {
  const safe = Math.max(0, seconds)
  const minutes = Math.floor(safe / 60)
  const remaining = safe - minutes * 60
  return `${String(minutes).padStart(2, '0')}:${remaining.toFixed(2).padStart(5, '0')}`
}

export function frameStepSeconds(nominalHz: number | undefined): number {
  if (!nominalHz || nominalHz <= 0) return 0.05
  return 1 / nominalHz
}

